export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8441.29a3b4c5.jpg";